module.exports = __webpack_public_path__ + "static/media/ico_phone_one.ec7645e6.svg";